<template>
    <form-wrapper @submit="handleFormSubmission(data)">
        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.auth.login.fields.email.label')"
                    :placeholder="$t('forms.auth.login.fields.email.placeholder')"
                    :hasAutofocus="true"
                    :isRequired="true"
                    :formData="data"
                    :error="errorMessage"
                    valuePath="email"
                    type="email"
                    @change="changeEmail($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.auth.login.fields.password.label')"
                    :placeholder="$t('forms.auth.login.fields.password.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    valuePath="password"
                    :type="passwordInputFieldType"
                    :maxLength="40"
                    @change="change($event)"
                >
                    <template #right>
                        <router-link :to="{ name: 'auth.forgot-password' }" tabindex="1">
                            {{ $t('forms.auth.login.microcopy.forgot_password') }}
                        </router-link>
                    </template>
                    <template #icon>
                        <common-toggle-visibility-button
                            @visibility-toggle-switch="showPassword"
                        ></common-toggle-visibility-button>
                    </template>
                </text-field>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    :isProcessing="isSending"
                    :label="$t('forms.auth.login.microcopy.login')"
                    type="primary"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import GoogleAnalyticsService from 'services/GoogleAnalyticsService'
    import PasswordToggleVisibilityMixin from 'mixins/PasswordToggleVisibilityMixin'
    import AuthAPI from 'api/AuthAPI'

    export default {
        mixins: [FormMixin, PasswordToggleVisibilityMixin],

        data() {
            return {
                errorMessage: null,
            }
        },

        methods: {
            handleFormSubmission({ email, password }) {
                this.handleRequest(AuthAPI.logIn(email, password))
                    .then((AuthenticationResult) => {
                        const { accessToken, idToken, refreshToken } = AuthenticationResult.signInUserSession
                        this.$auth.logIn(accessToken.jwtToken, idToken.jwtToken, refreshToken.token)
                        this.emitEvent({ name: 'sent' })

                        GoogleAnalyticsService.emitLogInGoogleAnalytics(this.$ga)
                    })
                    .catch(() => {
                        this.errorMessage = this.$t('forms.auth.login.microcopy.not_found_error')
                        this.data.password = ''
                    })
            },

            changeEmail(event) {
                this.change(event)
                this.errorMessage = ''
            },
        },

        mounted() {
            if (this.$route.query.email) {
                this.data.email = this.$route.query.email
            }
        },
    }
</script>
